import { useRef, useEffect, useState } from 'react';

/**
 * Adjusts the height of a textarea automatically based on its content.
 *
 * @example
 * const MyComponent = () => {
 *   const autosize = useAutosize();
 *   return (
 *     <textarea ref={autosize} />
 *   );
 * }
 */
function useAutosize() {
  const [node, setRef] = useState();
  const nodeRef = useRef(null);
  useEffect(() => {
    if (node) {
      // we have a reference to the node
      global.autosize(node);
      nodeRef.current = node;
    } else if (nodeRef.current) {
      // node was unmounted
      global.autosize.destroy(nodeRef.current);
      nodeRef.current = null;
    }
  }, [node]);
  return setRef;
}

export default useAutosize;
